export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(".panel-heading a").on("click", function (event) {
      event.preventDefault();

      $(this).parent().parent().toggleClass("active");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/modules.js